import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { fetchChapter } from '../api/book';

/**
 * 当前章节加载完成后，静默预加载前后章到 React Query 缓存。
 * 用户切换章节时命中缓存，零等待。
 */
export const usePrefetchChapters = (bookId, currentChapterId, chapters) => {
    const queryClient = useQueryClient();

    useEffect(() => {
        if (!bookId || !currentChapterId || !chapters.length) return;

        const idx = chapters.findIndex(c => c.id === currentChapterId);
        if (idx === -1) return;

        // 预加载下一章
        const next = chapters[idx + 1];
        if (next) {
            queryClient.prefetchQuery({
                queryKey: ['chapter', bookId, next.id],
                queryFn: () => fetchChapter(bookId, next.id),
            });
        }

        // 预加载上一章
        const prev = chapters[idx - 1];
        if (prev) {
            queryClient.prefetchQuery({
                queryKey: ['chapter', bookId, prev.id],
                queryFn: () => fetchChapter(bookId, prev.id),
            });
        }
    }, [bookId, currentChapterId, chapters, queryClient]);
};
